import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import InvoiceTableHeader from './InvoiceTableHeader';
import InvoiceTableRowBartey from './InvoiceTableRowBartey';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 36
    }, 
    logo: {
        width: 74,
        height: 66,
        //marginLeft: 'auto',
        //marginRight: 'auto'
    }
  });

  const info = [
    ["Actividad",	"Descripción",	"Puntaje"],
    [" ",	" ",	" "],
    
    ["Comer",	"Dependiente",  "0"],
    [" ", "Necesita ayuda para cortar, extender mantequilla, usar condimentos, etc.", "5"],
    [" ", "Independiente (capaz de usar cualquier instrumento)", "10"],
    [" ",	" ",	" "],
    ["Trasladarse entrela silla y la cama",	"Dependiente, no se mantiene sentado", "0"],
    [" ", "Necesita ayuda importante (1 persona entrenada o 2 personas), puede estar sentado","5"],
    [" ","Necesita algo de ayuda (una pequeña ayuda física o ayuda verbal)", "10"],
    [ " ","Independiente", "15"],
    [" ",	" ",	" "],
    [ "Aseo personal", "Dependiente",	"0"],
    [ " ","Independiente para lavarse la cara, las manos y los dientes, peinarse y afeitarse",	"5"],
    [" ",	" ",	" "],
    [ "Uso del retrete",	"Dependiente",	"0"],
    [ " ","Necesita alguna ayuda, pero puede hacer algo solo",	"5"],
    [ " ","Independiente (entrar y salir, limpiarse y vestirse)",	"10"],
    [" ",	" ",	" "],
    [ "Bañarse o Ducharse",	"Dependiente",	"0"],
    [ " ","Independiente para bañarse o ducharse",	"5"],
    [" ",	" ",	" "],
    [ "Desplazarse",	"Inmóvil",	"0"],
    [ " ","Independiente en silla de ruedas en 50 m", "5"],
    [ " ","Anda con pequeña ayuda de una persona (física o verbal)",	"10"],
    [ " ","Independiente al menos 50 m, con cualquier tipo de muleta, excepto andador",	"15"],
    [" ",	" ",	" "],
    [ "Subir y bajarescaleras",	"dependiente",	"0"],
    [ " ","Necesita ayuda física o verbal, puede llevar cualquier tipo de muleta",	"5"],
    [ " ","Independiente para subir y bajar",	"10"],
    [" ",	" ",	" "],
    [ "Vestirse y desvestirse",	"Dependiente",	"0"],
    [ " ","Necesita ayuda, pero puede hacer la mitad aproximadamente, sin ayuda",	"5"],
    [ " ","Independiente, incluyendo botones, cremalleras, cordones, etc.",	"10"],
    [" ",	" ",	" "],
    [ "Control de heces",	"Incontinente (o necesita que le suministren enema)",	"0"],
    [ " ","Accidente excepcional (uno/semana)",	"5"],
    [ " ","Continente",	"10"],
    [" ",	" ",	" "],
    ["Control de orina",	"Incontinente, o sondado incapaz de cambiarse la bolsa",	"0"],
    [ " ","Accidente excepcional (máximo uno/24 horas)",	"5"],
    [ " ","Continente durante al menos 7 días,",	"10"]
   ];
   const crossOutText = (barthel) => { 
    
    return [
    [" ",	"false",	" "],
    [" ",	" ",	" "],
    
    ["Comer", barthel.comer == 0,  "0"],
    [" ", barthel.comer == 5, "5"],
    [" ", barthel.comer == 10, "10"],
    [" ",	" ",	" "],
    ["Trasladarse entrela silla y la cama",	barthel.translate == 0, "0"],
    [" ", barthel.translate == 5,"5"],
    [" ",	barthel.translate == 10, "10"],
    [ " ", barthel.translate == 15, "15"],
    [" ",	" ",	" "],
    [ "Aseo personal", barthel.cleanPersonal == 0,	"0"],
    [ " ", barthel.cleanPersonal == 5,	"5"],
    [" ",	" ",	" "],
    [ "Uso del retrete",	barthel.retrete == 0,	"0"],
    [ " ",barthel.retrete == 5,	"5"],
    [ " ",barthel.retrete == 10,	"10"],
    [" ",	" ",	" "],
    [ "Bañarse o Ducharse",	barthel.bath == 0,	"0"],
    [ " ",barthel.bath == 5,	"5"],
    [" ",	" ",	" "],
    [ "Desplazarse", barthel.move == 0,	"0"],
    [ " ",barthel.move == 5, "5"],
    [ " ",barthel.move == 10,	"10"],
    [ " ",barthel.move == 15,	"15"],
    [" ",	" ",	" "],
    [ "Subir y bajarescaleras",  barthel.escalera == 0,	"0"],
    [ " ",barthel.escalera == 5,	"5"],
    [ " ",barthel.escalera == 10,	"10"],
    [" ",	" ",	" "],
    [ "Vestirse y desvestirse",	barthel.dressed == 0,	"0"],
    [ " ",barthel.dressed == 5,	"5"],
    [ " ",barthel.dressed == 10,	"10"],
    [" ",	" ",	" "],
    [ "Control de heces", barthel.heces == 0,	"0"],
    [ " ",barthel.heces == 5,	"5"],
    [ " ",barthel.heces == 10,	"10"],
    [" ",	" ",	" "],
    ["Control de orina",	barthel.orina == 0,	"0"],
    [ " ",barthel.orina == 5,	"5"],
    [ " ",barthel.orina == 10,	"10"]
   ];};
   
  const BarteyInfo = ({barthel}) => (
    <View style={styles.headerContainer}>
       
       <InvoiceTableHeader title={"Índice Barthel"}/>
        <InvoiceTableRowBartey items={info} crossOutText={crossOutText(barthel)}/>      
    </View>
  );
  
  export default BarteyInfo